module.exports = __webpack_public_path__ + "img/tutorial-06.1176f625.svg";